"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_MESSSAGE = exports.TEMPLATE_PARSING_ERROR_MESSAGE = exports.REQUEST_NULL = exports.TEMPLATE_PARSING = exports.ITG_CALL = exports.TEMPLATE_CALL = exports.ITG_INIT = exports.ENCRYPT_SUPPORTED_MESSAGE = exports.ENCRYPT_PADDING = exports.ENCRYPT_MODE = exports.ENCRYPT_TYPE = exports.NULL_REQUEST_MSG = exports.TEMPLATE_PARSING_ISSUE = exports.NULL_REQUEST = exports.ENCRYPT_NOT_SUPORTED = exports.TIMEOUT_CODE = exports.HTTP_ERROR_CODE = exports.HTTP_SUCCESS_MESSAGE = void 0;
exports.HTTP_SUCCESS_MESSAGE = 'success';
exports.HTTP_ERROR_CODE = 'http-0001';
exports.TIMEOUT_CODE = 'http-0002';
exports.ENCRYPT_NOT_SUPORTED = 'val-0001';
exports.NULL_REQUEST = 'val-0002';
exports.TEMPLATE_PARSING_ISSUE = 'val-0003';
exports.NULL_REQUEST_MSG = 'Please verify the request';
exports.ENCRYPT_TYPE = ['AES', 'DES', 'TripleDES', 'Rabbit', 'RC4', 'RC4Drop'];
exports.ENCRYPT_MODE = ['CBC', 'CFB', 'CTR', 'OFB', 'ECB'];
exports.ENCRYPT_PADDING = ['Pkcs7', 'Iso97971', 'AnsiX923', 'Iso10126', 'ZeroPadding', 'NoPadding'];
exports.ENCRYPT_SUPPORTED_MESSAGE = 'Sorry! The provided configuration is not supported';
exports.ITG_INIT = 'ITG_INIT';
exports.TEMPLATE_CALL = 'TEMPLATE_CALL';
exports.ITG_CALL = 'ITG_CALL';
exports.TEMPLATE_PARSING = 'TEMPLATE_PARSING';
exports.REQUEST_NULL = 'REQUEST_NULL';
exports.TEMPLATE_PARSING_ERROR_MESSAGE = 'Sorry! There is an issue with template parsing, please raise a ticket to our technical team.';
exports.DEFAULT_MESSSAGE = {
    messageValueMissing: 'Please fill out this field.',
    messageValueMissingCheckbox: 'This field is required.',
    messageValueMissingRadio: 'Please select a value.',
    messageValueMissingSelect: 'Please select a value.',
    messageTooShort: 'Please lengthen this text to {min} characters or more. You are currently using {length} characters.',
    messageTooLong: 'Please shorten this text to no more than {max} characters. You are currently using {length} characters.',
    messagePatternMismatch: 'Please match the format like {pattern}.',
    messageBadInput: 'Please enter a number.',
    messageRangeOverflow: 'Please select maximum {max}.',
    messageRangeUnderflow: 'Please select minimum {min}.',
    messageGeneric: 'The value you entered for this field is invalid.',
};
//# sourceMappingURL=common.js.map